export enum SeButtonEmphasis {
  Low = 'low',
  Medium = 'medium',
  High = 'high'
}